import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { getRandomSnapshotSelection } from '../sections/template-editor/utils/queries';

const RANDOM_SNAPSHOT_SELECTION_QUERY_KEY = 'randomSnapshotSelection';

export function useRandomSnapshotSelection(siteId: string | undefined, channel: 'onsite' | 'offsite') {
  const { t } = useTranslation(['designs', 'trackingLinks']);

  return useQuery(
    [RANDOM_SNAPSHOT_SELECTION_QUERY_KEY, siteId, channel],
    () => {
      if (!siteId) {
        return Promise.resolve([]);
      }
      return getRandomSnapshotSelection({ siteId, channel, t });
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
}
